import { TextInput } from "react-admin";
import React from "react";
import { useField } from "react-final-form";
import { emailValidation } from "../utils/validation";

interface IEmailInput {
  label: string;
  source: string;
}

const EmailInput = ({ label, source }: IEmailInput) => {
  const {
    input: { onChange, value },
  } = useField(source);

  return (
    <TextInput
      label={label}
      source={source}
      onChange={(e: any) => {
        const string: string = e.target.value;
        onChange(string.toLowerCase());
      }}
      type="email"
      validate={emailValidation}
    />
  );
};

export default EmailInput;
